import {
  BUILDER_SET_APPLY,
  BUILDER_ADD_ROW, BUILDER_ADD_SUB, BUILDER_DELETE_ROW,
  BUILDER_CHANGE_VALUE, BUILDER_TOGGLE_APPLY,
  BUILDER_SET,
} from './types';

export const setApply = applied => ({
  type: BUILDER_SET_APPLY,
  applied,
});

export const addRow = path => ({
  type: BUILDER_ADD_ROW,
  path,
});

export const addSub = path => ({
  type: BUILDER_ADD_SUB,
  path,
});

export const deleteRow = id => ({
  type: BUILDER_DELETE_ROW,
  id,
});


export const changeValue = (id, field, value) => ({
  type: BUILDER_CHANGE_VALUE,
  id, field, value,
});

export const toggleApply = () => ({
  type: BUILDER_TOGGLE_APPLY,
});

export const set = (payload, applied = true) => ({
  type: BUILDER_SET,
  payload, applied,
});
